module.exports = __webpack_public_path__ + "img/under-review-2.5fc698f1.svg";